export const POST_LOGBOOK_ENTRY = 'POST_LOGBOOK_ENTRY';
export const POST_LOGBOOK_ENTRY_SUCCESS = 'POST_LOGBOOK_ENTRY_SUCCESS';

export const POST_LOGBOOK_COMMENT = 'POST_LOGBOOK_COMMENT';
export const POST_LOGBOOK_COMMENT_SUCCESS = 'POST_LOGBOOK_COMMENT_SUCCESS';

export const POST_LOGBOOK_ADD_ENTRY = 'POST_LOGBOOK_ADD_ENTRY';
export const POST_LOGBOOK_ADD_ENTRY_SUCCESS = 'POST_LOGBOOK_ADD_ENTRY_SUCCESS';